import * as React from 'react';
import { Column, HeaderGroup } from '@tanstack/react-table';

export const getPinningStyles = (column: Column<any>): React.CSSProperties => {
  const isPinned = column.getIsPinned();

  return {
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    width: column.getSize(),
    zIndex: isPinned ? 1 : 0,
  };
};


export const pinColumns = ({
                             headerGroups,
                             leftPinnedColumns = [],
                             rightPinnedColumns = [],
                           }: {
  headerGroups: HeaderGroup<any>[],
  leftPinnedColumns?: string[],
  rightPinnedColumns?: string[],
}) => {

  for (const headerGroup of headerGroups) {
    for (const header of headerGroup.headers) {
      const columnId = header.column.id;
      if (leftPinnedColumns?.includes(columnId)) {
        header.column.pin('left');
      } else if (rightPinnedColumns?.includes(columnId)) {
        header.column.pin('right');
      }
    }
  }

};